import axios from 'axios';

// Configuration générale d'Axios
const api = axios.create({
  baseURL: 'https://ega-senegal.com/api', // Changez cela avec l'URL de votre backend
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("authToken")}`, 
  },
 
});

// Intercepteur pour gérer les erreurs globales
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Erreur API:', error.response || error.message);
    // afficher des messages utilisateur ici ou rediriger.
    return Promise.reject(error);
  }
);


// Fonction pour récupérer les publications
export const fetchPublications = async () => {
  try {
    const response = await api.get('/publications');
    return response.data; // Retourne les données de l'API
  } catch (error) {
    console.error('Erreur lors de la récupération des publications:', error);
    throw error;
  }
};

// Fonction pour récupérer les programmes
export const fetchPrograms = async () => {
  try {
    const response = await api.get('/programs');
    return response.data; // Retourne les données des programmes
  } catch (error) {
    console.error('Erreur lors de la récupération des programmes:', error);
    throw error;
  }
};

// Fonction pour gérer la connexion utilisateur
export const loginUser = async (data) => {
  try {
    const response = await api.post('/login', data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la connexion utilisateur:', error);
    throw error;
  }
};


export const likePublication = async (postId, token) => {
  return await fetch(`https://ega-senegal.com/api/publications/${postId}/like`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};


// Fonction pour gérer l'inscription utilisateur
export const registerUser = async (data) => {
  try {
    const response = await api.post('/register', data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'inscription utilisateur:', error);
    throw error;
  }
};

// Fonction pour faire une publication
export const createPublication = async (formData, token) => {
    try {
  
      // Envoi de la requête
      const response = await api.post('/publications/posts', formData, {
        headers: {
          'Authorization': `Bearer ${token}`, // 🔑 Ajout du token dans l'en-tête
          'Content-Type': 'multipart/form-data', // axios détecte ça automatiquement, mais on peut le garder pour être explicite
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la publication:', error);
      throw error;
    }
  };

 // Fonction pour faire un programme
  export const createProgram = async (formData, token) => {
    try {
  
      // Envoi de la requête
      const response = await api.post('/programs/', formData, {
        headers: {
          'Authorization': `Bearer ${token}`, // 🔑 Ajout du token dans l'en-tête
          'Content-Type': 'multipart/form-data', // axios détecte ça automatiquement, mais on peut le garder pour être explicite
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la publication:', error);
      throw error;
    }
  }; 
  
// Fonction pour creer une actualité
export const createNews = async (formData, token) => {
  try {

    // Envoi de la requête
    const response = await api.post('/news', formData, {
      headers: {
        'Authorization': `Bearer ${token}`, // 🔑 Ajout du token dans l'en-tête
        'Content-Type': 'multipart/form-data', // axios détecte ça automatiquement, mais on peut le garder pour être explicite
      },
    });
    
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la publication du news:', error);
    throw error;
  }
};


export const updateUserProfile = async (userId, data) => {
  const response = await fetch(`https://ega-senegal.com/api/users/${userId}`, {
    method: 'PUT',
    body: data, // ✅ Toujours envoyer FormData
  });

  if (!response.ok) {
    throw new Error("Échec de la mise à jour du profil.");
  }

  return response.json();
};

// fonction pour s'abonner
export const followUniversity = async (universityId, token) => {
  return await fetch(`https://ega-senegal.com/api/follow/${universityId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// fonction pour candidater
export const candidateToProgram = async (programId, token) => {
  return await fetch(`https://ega-senegal.com/api/programs/${programId}/apply`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Fonction pour récupérer les candidatures par étudiants
export const getCandidatures = async (userId) => {
  if (!userId) throw new Error("L'ID utilisateur est requis");

  try {
    const response = await api.get(`/candidatures/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des candidatures:', error.response?.data || error.message);
    throw error;
  }
};


  
// Pour supprimer une publication
export const deletePublication = async (id) => {
  try {
    const response = await api.delete(`/publications/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression de la publication:', error);
    throw error;
  }
};
// Pour mettre à jour une publication
export const updatePublication = async (id, data) => {
  try {
    const response = await api.put(`/publications/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la publication:', error);
    throw error;
  }
};

// Pour supprimer un Programme
export const deleteProgram = async (id) => {
  try {
    const response = await api.delete(`/programs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression du programme:', error);
    throw error;
  }
};
// Pour mettre à jour un Programme
export const updateProgram = async (id, data) => {
  try {
    const response = await api.put(`/programs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du programme:', error);
    throw error;
  }
};

export default api;
